import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { H2 } from 'foundations-components/transitional/components/H2';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledSection from '../publicLayout/components/StyledSection';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrendingTopicButton = ({
  topicName,
  children
}) => /*#__PURE__*/_jsx(RouterButton, {
  to: `/courses?cat=${topicName}`,
  use: "tertiary-light",
  children: children
});
const TrendingTopicsSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    "data-test-id": "trending-topics-section",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(StyledSection, {
      backgroundColor: "fill-surface-recessed",
      paddingBlock: "1200",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "1000",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.trendingTopics.title"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexWrap: "wrap",
          justifyContent: "center",
          rowGap: isMobile ? '100' : '300',
          children: [/*#__PURE__*/_jsx(TrendingTopicButton, {
            topicName: "SOCIAL_MEDIA",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.trendingTopics.socialMedia"
            })
          }), /*#__PURE__*/_jsx(TrendingTopicButton, {
            topicName: "EMAIL_MARKETING",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.trendingTopics.emailMarketing"
            })
          }), /*#__PURE__*/_jsx(TrendingTopicButton, {
            topicName: "SEO",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.trendingTopics.seo"
            })
          }), /*#__PURE__*/_jsx(TrendingTopicButton, {
            topicName: "INBOUND_SALES",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.trendingTopics.inboundSales"
            })
          }), /*#__PURE__*/_jsx(TrendingTopicButton, {
            topicName: "CONTENT_MARKETING",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.trendingTopics.contentMarketing"
            })
          })]
        })]
      })
    })
  });
};
export default TrendingTopicsSection;